import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Card, Typography, Grid, Grow, Paper, Link, CircularProgress } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from '../header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import blayzeImage1 from '../../../images/newsletter/e1/blayze2.png';
import comicImage1 from '../../../images/newsletter/e1/comic1.png';
import lightImage1 from '../../../images/newsletter/e1/light1.png';
import NoteComponent from '../social/notes/NoteComponent';

import { useSearchParams } from 'react-router-dom';
import { Flash } from "react-ruffle";
import FlashPlayer from '../adobeanimate/FlashPlayer';


function DisplayNoteGrid({ latestNotes, firstLoad }) {
    const karmaContext = useKarmaPoolContext();

    return (
        <Box sx={{ marginBottom: "1.0rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={2}>
                {latestNotes != null && latestNotes.length > 0 && !firstLoad ? (
                    <>
                        {latestNotes.map((note) => {
                            return (
                                <Grid item key={note.id} xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                    <NoteComponent note={note} neverExpires={true} hideGenre={true} />
                                </Grid>
                            );
                        })}
                    </>) :
                    (karmaContext.noteManager.isLoadingNotes() || firstLoad ?
                        <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Typography variant="body2" component="div" gutterBottom sx={{ color: "rgba(221, 221, 221, 0.375)" }}>
                                <CircularProgress variant="indeterminate" size={24} sx={{ color: "rgba(221, 221, 221, 0.775)" }} />
                            </Typography>
                        </Grid>
                        :
                        (latestNotes === null ?
                            (
                                <></>
                            )
                            :
                            (
                                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>

                                </Grid>
                            )
                        ))}
            </Grid>
        </Box>
    );
}


function Newsletter(props) {

    const karmaContext = useKarmaPoolContext();

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            //window.location.href = "/karma";
        }
    }

    const [firstLoad, setFirstLoad] = useState(true);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        karmaContext.noteManager.clearLatestNotes();
        karmaContext.noteManager.setTopFilter({ newsletterOnly: true, newsletterId: getNewsletterId() });
    }, []);

    useEffect(() => {
        setLatestNotes(karmaContext.local.latestNotes);
        //setFirstLoad(false);
    }, [karmaContext.local.latestNotes]);

    useEffect(() => {
        karmaContext.noteManager.clearLatestNotes();
        karmaContext.noteManager.setTopFilter({ newsletterOnly: true, newsletterId: getNewsletterId() });
    }, [props.newsletterId]);

    const [latestNotes, setLatestNotes] = useState(null);

    useEffect(() => {
        setFirstLoad(false);
    }, [latestNotes]);

    function getNewsletterId() {
        const id = searchParams.get('id'); // Get the 'id' parameter from the URL

        if (id !== null) {
            return parseInt(id);
        }

        return props.newsletterId === undefined ? karmaContext.local.pool.latestNewsletterId : props.newsletterId;
    }

    function goNextNewsletter() {
        const currentId = getNewsletterId();
        const nextId = currentId + 1;
        window.location.href = `?id=${nextId}`;
    }

    function goPreviousNewsletter() {
        const currentId = getNewsletterId();
        const prevId = Math.max(currentId - 1, 1); // Ensuring the ID doesn't go below 1
        window.location.href = `?id=${prevId}`;
    }

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.0em", color: "whitesmoke" }}>
                    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.0rem" }}>
                        <Box sx={{ padding: "0.25rem", width: "18rem", height: "3.5rem" }}>
                            <Typography variant="h5" color="text.secondary" sx={{ marginTop: "0.0em", color: "whitesmoke" }}>
                                <strong> Newsletter - Edition #{getNewsletterId()} </strong>
                            </Typography>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <IconButton
                                onClick={getNewsletterId() > 1 ? goPreviousNewsletter : undefined}
                                aria-label="previous newsletter"
                                color={getNewsletterId() > 1 ? "secondary" : undefined}
                                sx={{
                                    color: getNewsletterId() > 1 ? undefined : 'rgba(255, 255, 255, 0.35)'
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            {getPublishedDate(getNewsletterId())}
                            <IconButton
                                onClick={getNewsletterId() < 4 ? goNextNewsletter : undefined}
                                aria-label="next newsletter"
                                color={getNewsletterId() < 4 ? "secondary" : undefined}
                                sx={{
                                    color: getNewsletterId() < 4 ? undefined : 'rgba(255, 255, 255, 0.35)'
                                }}
                            >
                                <ArrowForwardIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Paper sx={{ marginTop: "2.5rem" }} />

                    <Paper sx={{ marginTop: "2.25rem" }} />
                    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.0rem" }}>
                        <DisplayNoteGrid latestNotes={latestNotes} firstLoad={firstLoad} />
                    </Box>
                    <Box sx={{ marginBottom: "0.75rem" }} />
                    <Link href={"/karma/dashboard/"} >
                        <strong>back</strong>
                    </Link>
                    <Box sx={{ marginBottom: "3.25rem" }} />
                </Typography>
            </Box>
        </>
    );
}

function getPublishedDate(id) {
    if (id === 1) {
        return "published 1st Oct, 2023";
    }
    else if (id === 2) {
        return "published 1st Oct, 2024";
    }
    else if (id === 3) {
        return "published 1st Oct, 2025";
    }
    else if (id === 4) {
        return "published 1st Oct, 2026";
    }
    else {
        return "not published yet";
    }
}

export default Newsletter;


